import './Contact.css'
import ContactForm from '../ContactForm/ContactForm'
import Aos from 'aos'
import "aos/dist/aos.css"
import { useEffect } from 'react'
import { mobileCheck } from '../../../../Misc/essential'
 export default function Contact(){
	 useEffect(()=>{
		Aos.init({
			once:true,
			duration: 1500,
			disable: mobileCheck()
		})
	 },[])
 	return (
 		<div className='contact mt-60' id="contact">
			 <div className="contact-content lg:w-2/3 w-full lg:mx-auto flex flex-col lg:flex-row space-x-0 lg:space-x-10 items-center
			 	space-y-10 lg:space-y-0
			 " data-aos="">
				 <div className="contact-text grow shrink basis-0" data-aos="zoom-in-right">
					 <div className="sub border-x-[6px] lg:border-r-0 border-orange-500 px-5 md:text-7xl text-5xl font-medium mx-auto lg:mx-0 w-fit">Contact</div>
					 <div className="text mt-5 leading-8 px-4 lg:text-left text-justify md:text-3xl text-xl font-light">
					 I hope I got your interest. If you have any opportunity for me, don't hesitate, send me message.
					  Further more, you can offer me to anybody else who need websites.
					 </div>
				 </div>
				 <div className="contact-form grow shrink basis-0 w-full" data-aos="fade-left" 
				 
				 data-aos-duration="2200">
					<ContactForm/>
				 </div>
			 </div>
 		</div>
 	)
 }